import React from 'react';

const Section = ({ id, children, className = "", ...props }) => {
  return (
    <section
      id={id}
      className={`section-padding scroll-mt-20 ${className}`}
      {...props}
    >
      <div className="container-custom">
        {children}
      </div>
    </section>
  );
};

export default Section;
